import { render, staticRenderFns } from "./VariantListInput.vue?vue&type=template&id=31945c3a"
import script from "./VariantListInput.vue?vue&type=script&lang=js"
export * from "./VariantListInput.vue?vue&type=script&lang=js"
import style0 from "./VariantListInput.vue?vue&type=style&index=0&id=31945c3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports